module.exports = __webpack_public_path__ + "img/cg_title_icon.32228c8.png";